import { createAction } from '@reduxjs/toolkit';

export const getUserPersonalData = createAction<string>('userPage/getUserPersonalData');
